import PMBPagination from 'components/PMBPagination'
import { TableComponent as DataTable } from 'components/TableComponent'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, Spinner } from 'reactstrap'
import { useFetchFarmersV2Query } from '../farmers-list/farmersListApiSlice'
import { setFetchOptionPending } from '../farmers-list/farmersListSlice'
import BreadCrumbs from 'components/breadcrumbs'

const FarmersPendingList = () => {
  const { tagPending } = useSelector((s) => s.farmersList)

  const code = window.location.href.substring(
    window.location.href.lastIndexOf('/') + 1,
  )
  const dispatch = useDispatch()

  let [page, setPage] = useState({ page: tagPending.page })

  const {
    data: dataPending,
    isLoading: isLoadingPending,
    refetch: refetchPending,
  } = useFetchFarmersV2Query(
    {
      size: tagPending?.size,
      page: tagPending?.page,
      status: 'PENDING',
    },
    { skip: !page },
  )

  const columns = [
    {
      name: 'Nama',
      cell: (row) => {
        return (
          <div data-testid={`farmer-member-row-${row?.userId}`}>
            <span>{row?.name}</span>
          </div>
        )
      },
    },
    {
      name: 'Nomor Telepon',
      cell: (row) => {
        return <span>{row?.phoneNumber}</span>
      },
    },
    {
      name: 'Grup',
      cell: (row) => {
        return <span>{row?.groupName}</span>
      },
    },
  ]

  return (
    <div className="w-100 px-3 py-3">
      <BreadCrumbs
        breadCrumbActive={'Menunggu Konfirmasi'}
        breadCrumbParent={'Daftar Anggota'}
        breadCrumbParentLink={'/farmers'}
      />
      <Card className="border-0 shadow-sm">
        <CardBody>
          <DataTable
            columns={columns}
            data={dataPending?.items}
            progressPending={isLoadingPending}
            progressComponent={<Spinner />}
            noDataComponent={
              <p className="my-3 fw-semibold">
                Belum ada pengguna yang didaftarkan
              </p>
            }
            subHeader
            subHeaderAlign="left"
            subHeaderComponent={
              <div className='d-flex flex-wrap flex-column'>
                <h5 className="fw-semibold">Menunggu Konfirmasi Anggota</h5>
                <p>
                  Anggota yang sudah memiliki akun perlu melakukan konfirmasi
                  via WhatsApp agar dapat bergabung sepenuhnya. Anda tetap bisa
                  menambahkan anggota lainnya sambil menunggu.
                </p>
              </div>
            }
            pagination
            paginationServer
            paginationComponent={(props) => (
              <PMBPagination
                rowCount={dataPending?.totalItems || 0}
                currentPage={tagPending?.page}
                rowsPerPage={tagPending?.size}
                setCurrentPage={(e) => {
                  dispatch(setFetchOptionPending({ page: e }))
                }}
                setRowsPerPage={(e) => {
                  dispatch(setFetchOptionPending({ size: e }))
                }}
                props={props}
                testId="farmer-pending-pagination"
              />
            )}
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default FarmersPendingList
